import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, UrlSerializer, CanActivateFn, CanActivateChildFn } from '@angular/router'
import { AuthService } from '@app/modules/auth/auth.service'
import { merge, of, Observable } from 'rxjs'
import { filter, first, switchMap } from 'rxjs/operators'

export const noAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService)
  const urlSerializer = inject(UrlSerializer)
  const isLoggedIn$ = authService.isLoggedIn$

  const isNotLoggedIn = (isLoggedIn) => !isLoggedIn
  const canActivateRoute = (isLoggedIn) => of(!isLoggedIn)

  const canActivate$ = isLoggedIn$.pipe(filter(isNotLoggedIn), switchMap(canActivateRoute))

  const currentUser$ = isLoggedIn$.pipe(
    filter(Boolean),
    switchMap(() => authService.currentUser$),
  )

  const adminRedirect$ = currentUser$.pipe(
    filter((user) => user.isAdmin()),
    switchMap(() => of(urlSerializer.parse('/admin'))),
  )

  const clientRedirect$ = currentUser$.pipe(
    filter((user) => user.isClient()),
    switchMap(() => of(urlSerializer.parse('/client'))),
  )

  const resellerRedirect$ = currentUser$.pipe(
    filter((user) => user.isReseller()),
    switchMap(() => of(urlSerializer.parse('/reseller'))),
  )

  return merge(canActivate$, adminRedirect$, clientRedirect$, resellerRedirect$).pipe(first())
}

export const noAuthChildGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return noAuthGuard(route, state)
}
